import { useEffect, useState } from "react";
import { ExternalLink, Hotel, Clock } from "lucide-react";
import api from "@/lib/api";
import { AffiliateDeals } from "@/components/AffiliateDeals";

// Travelpayouts stays near the cruise region + Cuelinks cruise/travel deals.
// Both render nothing unless the partner is genuinely connected (truthful, no fabricated offers).
const outHref = (u, m = "") => `/out?u=${encodeURIComponent(u || "")}&src=travelpayouts${m ? `&m=${encodeURIComponent(m)}` : ""}`;

function StaysNearby({ region }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!region) { setData(null); return; }
    const qs = new URLSearchParams({ travel_type: "hotel", destination: region, q: region });
    api.get(`/services/external-comparison?${qs.toString()}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [region]);
  if (!data || !data.enabled) return null;
  const opts = (data.options || []).slice(0, 6);
  if (!opts.length) return null;
  return (
    <div className="mb-6 rounded-2xl border border-sky-100 bg-sky-50/40 p-4" data-testid="cruise-stays-nearby">
      <p className="mb-3 flex items-center gap-1.5 text-sm font-bold text-slate-900"><Hotel className="h-4 w-4 text-sky-600" /> Stays near {region} — from travel partners</p>
      <div className="space-y-2">
        {opts.map((o, i) => (
          <a key={i} href={outHref(o.url, o.provider_name)} target="_blank" rel="nofollow sponsored noopener noreferrer" data-testid={`cruise-stay-${i}`} className="flex items-center justify-between gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm hover:border-sky-300">
            <span className="min-w-0 truncate"><span className="font-semibold text-slate-800">{o.title || o.provider_name}</span> <span className="text-xs text-slate-400">· {o.provider_name}</span></span>
            <span className="flex items-center gap-2 whitespace-nowrap">{o.price != null && <span className="font-semibold text-slate-800">₹{o.price}</span>}<ExternalLink className="h-3.5 w-3.5 text-slate-400" /></span>
          </a>
        ))}
      </div>
      {data.note && <p className="mt-3 flex items-center gap-1 text-[11px] text-slate-400"><Clock className="h-3 w-3" /> {data.note}</p>}
    </div>
  );
}

export default function CruisePartners({ region = "", query = "cruise" }) {
  return (
    <section data-testid="cruise-partners">
      <StaysNearby region={region} />
      <AffiliateDeals module="travel" query={query} />
    </section>
  );
}
